import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div<{ $isHidden: boolean }>`
  display: grid;
  grid-template-columns: 17px 1fr auto;
  align-items: center;
  gap: 10px;
  border-radius: 14px;
  background-color: ${({ theme, $isHidden }) =>
    $isHidden
      ? theme.palette.secondary.background
      : theme.palette.primary.background};
  padding: 0 20px;
  height: 55px;

  ${({ theme, $isHidden }) =>
    !$isHidden &&
    css`
      border: 1px solid ${theme.palette.system.blue};
    `};
`;

export const Number = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Action = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration: underline;
  line-height: 1;
`;
